export const AcmeApp_Dev_WorkloadId = "580c38257d8c018ec5a8585eb95a455d";
export const AcmeApp_Staging_WorkloadId = "70e6ae7a140de130360d1d6ad17e5467";
export const AcmeApp_Prod_WorkloadId = "74f82e17cc7736c5203ad1774f5c25f6";
export const Acme_Research_App_WorkloadId = "77d6a9af2e801f2d1c2a69d123f594eb";

export const AcmeApp_Dev_MOCK = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2023-10-03",
  PillarReviewSummaries: [
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 10,
        MEDIUM: 1,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 0,
      },
    },
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 10,
        MEDIUM: 1,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 0,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 11,
        MEDIUM: 1,
        NONE: 1,
        NOT_APPLICABLE: 0,
        UNANSWERED: 0,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 4,
        MEDIUM: 1,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 0,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 7,
        MEDIUM: 3,
        NONE: 1,
        NOT_APPLICABLE: 0,
        UNANSWERED: 0,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 5,
        NONE: 1,
        NOT_APPLICABLE: 0,
        UNANSWERED: 0,
      },
    },
  ],
  RiskCounts: {
    HIGH: 42,
    MEDIUM: 12,
    NONE: 3,
    NOT_APPLICABLE: 0,
    UNANSWERED: 0,
  },
  UpdatedAt: "2023-11-21 09:32:32+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 57,
    CreatedAt: "2023-10-12 19:17:19",
    Description: "Acme Inc's primary application, Dev Environment",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Douglas",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 42,
      Medium: 12,
    },
    Scope: [
      {
        Applications: [
          "a6fcb744-5777-43ec-bfd3-2026b5749452",
          "be23455c-5361-427a-bbb4-b8af60d53c54",
        ],
        Department: "ae03391d-7ce9-4a73-adbf-61a3ed260e0f",
      },
    ],
    Status: "PENDING",
    TotalQuestions: 57,
    UpdatedAt: "2023-11-18 12:42:42",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:984532411092:workload/580c38257d8c018ec5a8585eb95a455d",
    WorkloadId: "580c38257d8c018ec5a8585eb95a455d",
    WorkloadName: "AcmeApp_Dev",
  },
};

export const AcmeApp_Staging_MOCK = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "NOT_CURRENT",
  LensVersion: "2023-04-10",
  PillarReviewSummaries: [
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 3,
        MEDIUM: 2,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 6,
        MEDIUM: 1,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 4,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 7,
        MEDIUM: 1,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 5,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 5,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
  ],
  RiskCounts: {
    HIGH: 21,
    MEDIUM: 4,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 35,
  },
  UpdatedAt: "2023-11-18 12:33:41+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 25,
    CreatedAt: "2023-09-26 19:38:07",
    Description: "Acme Inc's primary application, Staging Environment",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: "Environmental_Protection",
    IndustryType: "Environmental_Protection",
    Lenses: "AWS Well-Architected Framework",
    Owner: "Marv",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 21,
      Medium: 4,
    },
    Scope: [
      {
        AccountNumber: "100197857259",
        Regions: ["us-east-1"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 60,
    UpdatedAt: "2023-11-18 12:44:17",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:984532411092:workload/70e6ae7a140de130360d1d6ad17e5467",
    WorkloadId: "70e6ae7a140de130360d1d6ad17e5467",
    WorkloadName: "AcmeApp_Staging",
  },
};

export const AcmeApp_Prod_MOCK = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "NOT_CURRENT",
  LensVersion: "2023-04-10",
  PillarReviewSummaries: [
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 2,
        MEDIUM: 2,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 7,
      },
    },
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 2,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 9,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 1,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 12,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 1,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 7,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 1,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 1,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 5,
      },
    },
  ],
  RiskCounts: {
    HIGH: 7,
    MEDIUM: 3,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 50,
  },
  UpdatedAt: "2023-11-21 14:44:22+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 10,
    CreatedAt: "2023-09-21 01:00:51",
    Description: "Acme Inc's primary application, Prod Environment",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 0,
    Industry: "Power_Utilities_Other",
    IndustryType: "Power_Utilities",
    Lenses: "AWS Well-Architected Framework",
    Owner: "Adams",
    RegionCode: "ap-south-1",
    RiskCounts: {
      High: 7,
      Medium: 3,
    },
    Scope: [
      {
        Applications: ["86bf0411-eaea-41b6-b173-a3a3bd55a794"],
        Department: "7bc676d3-deff-4c6c-973b-ac87cfcb75f5",
      },
    ],
    Status: "PENDING",
    TotalQuestions: 60,
    UpdatedAt: "2023-11-18 12:39:45",
    WorkloadArn:
      "arn:aws:wellarchitected:ap-south-1:984532411092:workload/74f82e17cc7736c5203ad1774f5c25f6",
    WorkloadId: "74f82e17cc7736c5203ad1774f5c25f6",
    WorkloadName: "AcmeApp_Prod",
  },
};

export const Acme_Research_App_Mock = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "NOT_CURRENT",
  LensVersion: "2023-04-10",
  PillarReviewSummaries: [
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 60,
  },
  UpdatedAt: "2023-09-19 00:13:10+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-09-18 10:51:02",
    Description: "Acme Inc's  research team's development environment ",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 0,
    Industry: "Environmental_Protection",
    IndustryType: "Environmental_Protection",
    Lenses: "AWS Well-Architected Framework",
    Owner: "Tagore",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        Applications: ["33984c96-720a-40c9-891d-1b07d9f18611"],
        Department: "7bc676d3-deff-4c6c-973b-ac87cfcb75f5",
      },
    ],
    Status: "PENDING",
    TotalQuestions: 60,
    UpdatedAt: "2023-11-18 06:38:30",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:984532411092:workload/77d6a9af2e801f2d1c2a69d123f594eb",
    WorkloadId: "77d6a9af2e801f2d1c2a69d123f594eb",
    WorkloadName: "Acme_Research_App",
  },
};
